/* eslint-disable no-undef */
// Load all the controllers within this directory and all subdirectories.
// Controller files must be named *_controller.js.

import { Application } from "stimulus"
import PriceComponentController from '../../components/price_component_controller';
import VideoPlayerController from '../../components/media/video_player_controller';
import AudioPlayerController from '../../components/media/audio_player_controller';
import DropdownController from '../../components/dropdown_controller';
import AddButtonController from '../../../engines/subscriber_v2/app/components/subscriber_v2/add_button_controller';

export default function initApplication(root) {

  console.log("initApplication", root);
  const application = Application.start(root);

  // Whitelist the controllers we want to use to keep embed small
  application.register("price-component", PriceComponentController);
  application.register("media--video-player", VideoPlayerController);
  application.register("media--audio-player", AudioPlayerController);
  application.register("dropdown", DropdownController);
  application.register("add-button", AddButtonController);

  return application;
}